<template>
  <div class="error-warning">
    <div class="error-warning__icon-wrapper">
      <a-icon
        :icon="$options.consts.ICON.WARNING_404"
        :width="202"
        :height="184"
        original
        class="error-warning__icon"
      />
    </div>
    <h1 v-if="title" class="error-warning__message">
      {{ title }}
    </h1>
    <p class="error-warning__code text-body bold">{{ statusCode }}</p>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AIcon, { ICON } from 'shared/AIcon/index.vue'

const DEFAULT_TITLE = 'Page Not Found'

export default {
  name: 'AWarning',
  components: {
    AIcon
  },
  consts: {
    ICON
  },
  props: {
    statusCode: propValidator([PROP_TYPES.NUMBER]),
    title: propValidator([PROP_TYPES.STRING], false, DEFAULT_TITLE)
  }
}
</script>

<style lang="scss" scoped>
.error-warning {
  align-items: center;
  padding: 24px 0;
  max-height: 470px;
  max-width: 400px;
  overflow: hidden;

  @include mobile {
    margin: 0 auto;
  }

  .error-warning__image {
    width: 100%;
  }

  .error-warning__message {
    margin-top: -20px;

    @include mobile {
      margin-top: -32px;
    }
  }

  .error-warning__code {
    color: $c--main;
    margin-top: 8px;
  }
}
</style>
